const HIGH_DELAY_THRESHOLD = 100; // seconds
const HIGH_EMAIL_VOLUME_THRESHOLD = 5000; // emails
const HIGH_REJECTION_RATE_THRESHOLD = 5; // percentage
const DOCUMENTS_EXTENSIONS = [
  "doc",
  "docx",
  "docm",
  "xls",
  "xlsx",
  "xlsm",
  "pdf",
  "rtf",
  "ppt",
  "pptx",
  "pptm",
];

export const isEmpty = (obj) => {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return true;
};

// IANA time zone of the browser, so dashboard days and hours match the viewer's clock
export const viewerTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch (e) {
    return "UTC";
  }
};

export const getAlertsFromDashboardData = (dashboardData) => {
  const newAlerts = [];

  // High Delay Alert
  const avgDelay = dashboardData.avgDelay || 0;
  if (avgDelay > HIGH_DELAY_THRESHOLD) {
    newAlerts.push(
      `High Delay Alert: Average delay is ${avgDelay.toFixed(
        2,
      )} seconds (Threshold: ${HIGH_DELAY_THRESHOLD} seconds)`,
    );
  }

  // High Email Volume Alert
  const maxEmailsInADay = Math.max(0, ...Object.values(dashboardData.emailVolume || {}));
  if (maxEmailsInADay > HIGH_EMAIL_VOLUME_THRESHOLD) {
    newAlerts.push(
      `High Email Volume Alert: ${maxEmailsInADay} emails sent in a day (Threshold: ${HIGH_EMAIL_VOLUME_THRESHOLD} emails)`,
    );
  }

  // High Rejection Rate Alert (mail blocked by the gateway is not a delivery failure)
  const rejectionRate = dashboardData.failures?.rate || 0;
  if (rejectionRate > HIGH_REJECTION_RATE_THRESHOLD) {
    newAlerts.push(
      `High Rejection Rate Alert: ${rejectionRate.toFixed(
        2,
      )}% rejection rate (Threshold: ${HIGH_REJECTION_RATE_THRESHOLD}%)`,
    );
  }

  return newAlerts;
};

export const checkCdrFromExtension = (fileExt) => {
  if (fileExt && DOCUMENTS_EXTENSIONS.indexOf(fileExt.toLowerCase()) > -1) return true;
  return false;
};
